export default function (field) {
    return {
        type: 'DONE',
        field
    }
}